import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

  interface InfoSectionProps {
    title?: string;          // Title of the section
    content: string;        // Content of the section
    positionX?: string;     // Horizontal position (default is '50%')
    positionY?: string;     // Vertical position (default is '50%')
    showCloseIcon?: boolean; // Whether to show the close icon (default is false)
    width?: string;     // Dynamic width of the section (default is '350px')
    onClose?: () => void;
    style?: React.CSSProperties;
    arrowPosClassName?: string;
  }


  const InfoSection: React.FC<InfoSectionProps> = ({
    title,
    content,
    positionX = '50%',
    positionY = '50%',
    showCloseIcon = false,
    width = '350px',  // Default width if not provided
    onClose,         // Handler for close event
    style = {}, // Default inline style
    arrowPosClassName = '',
  }) => {
    return (
      <Box
        component="div"
        sx={{
          position: 'fixed',
          top: positionY,
          left: positionX,
          transform: 'translate(-50%, -50%)',
          padding: '12px',
          background: 'rgba(207,230,229,0.9)',
          width: width,
          borderRadius: '10px',
          zIndex: 1000, // Ensure the box is above other content
          ...style, // Merge inline style with default styles
        }}
        className={`information_tip ${arrowPosClassName}`}
      >
        {showCloseIcon && (
          <Box component="div" sx={{ position: 'absolute', top: '0px', right: '0px' }}>
            <IconButton onClick={onClose} sx={{ color: '#25282b' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        )}

        {/* Render title only if it's provided */}
        {title && (
          <Typography sx={{ textAlign: 'center', fontSize: '20px', fontWeight: '700', color: '#25282b', marginTop: '15px' }}>
            {title}
          </Typography>
        )}
        <Typography sx={{ textAlign: 'center', fontSize: '14px', color: '#25282b' }}>
          {content}
        </Typography>
      </Box>
    );
  };

  export default InfoSection;